import {getSpiideoVenueLabel} from '@modules/spiideoMappings/utils/helpers';

export const exportExcel = (dataExport) => ({
    dataExport: dataExport,
    filename: 'spiideo_venue_mappings',
    parseData: mapping => [
        getSpiideoVenueLabel(mapping.stadium),
        mapping.spiideo_scene_uuid || '',
    ],
    path: 'spiideoMappings.venues.path',
    titles: [
        'Venue',
        'Spiideo scene UUID',
    ],
});
